import React from 'react';
import { LandingPage } from './pages/LandingPage';
import { HowItWorksPage } from './pages/HowItWorksPage';
export function App() {
  // Simple routing based on pathname
  const path = window.location.pathname;
  if (path === '/how-it-works') {
    return <HowItWorksPage data-id="element-0" />;
  }
  return <LandingPage data-id="element-1" />;
}